module.exports = __webpack_public_path__ + "img/house-person-return.8ce1fee5.svg";